import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconBagStriped({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<path
					id="a"
					d="M.336.038V10.74h8.25c.361-.27.587-.71.558-1.195L8.584.038"
				/>
				<path
					id="c"
					d="M.336.038V10.74h8.25c.361-.27.587-.71.558-1.195L8.584.038"
				/>
				<path
					id="e"
					d="M.336.038V10.74h8.25c.361-.27.587-.71.558-1.195L8.584.038z"
				/>
				<path
					id="g"
					d="M.336.038V10.74h8.25c.361-.27.587-.71.558-1.195L8.584.038"
				/>
				<path
					id="i"
					d="M.336.038V10.74h8.25c.361-.27.587-.71.558-1.195L8.584.038"
				/>
				<path
					id="k"
					d="M.336.038V10.74h8.25c.361-.27.587-.71.558-1.195L8.584.038"
				/>
				<path
					id="m"
					d="M.336.038V10.74h8.25c.361-.27.587-.71.558-1.195L8.584.038"
				/>
				<path
					id="o"
					d="M.336.038V10.74h8.25c.361-.27.587-.71.558-1.195L8.584.038z"
				/>
				<path
					id="q"
					d="M.336.038V10.74h8.25c.361-.27.587-.71.558-1.195L8.584.038"
				/>
				<path
					id="s"
					d="M.336.038V10.74h8.25c.361-.27.587-.71.558-1.195L8.584.038"
				/>
				<path
					id="u"
					d="m.759.038-.56 9.488c-.028.494.202.94.572 1.214h7.422V.038"
				/>
				<path
					id="w"
					d="m.759.038-.56 9.488c-.028.494.202.94.572 1.214h7.422V.038"
				/>
				<path
					id="y"
					d="m.759.038-.56 9.488c-.028.494.202.94.572 1.214h7.422V.038z"
				/>
				<path
					id="A"
					d="m.759.038-.56 9.488c-.028.494.202.94.572 1.214h7.422V.038"
				/>
				<path
					id="C"
					d="m.759.038-.56 9.488c-.028.494.202.94.572 1.214h7.422V.038"
				/>
				<path
					id="E"
					d="m.759.038-.56 9.488c-.028.494.202.94.572 1.214h7.422V.038"
				/>
				<path
					id="G"
					d="m.759.038-.56 9.488c-.028.494.202.94.572 1.214h7.422V.038"
				/>
				<path
					id="I"
					d="m.759.038-.56 9.488c-.028.494.202.94.572 1.214h7.422V.038z"
				/>
				<path
					id="K"
					d="m.759.038-.56 9.488c-.028.494.202.94.572 1.214h7.422V.038"
				/>
				<path
					id="M"
					d="m.759.038-.56 9.488c-.028.494.202.94.572 1.214h7.422V.038"
				/>
			</defs>
			<g fill="none" fillRule="evenodd">
				<path
					fill="#CD0400"
					d="M19.284 22.71H5.308c-.819 0-1.47-.683-1.422-1.493l.779-13.202a1.42 1.42 0 0 1 1.423-1.33h12.4c.754 0 1.377.582 1.42 1.328l.78 13.222c.047.8-.595 1.475-1.404 1.475"
				/>
				<path
					fill="#FFF"
					d="M18.577 22.01H4.602c-.82 0-1.47-.683-1.422-1.493l.778-13.202a1.42 1.42 0 0 1 1.424-1.33H17.78c.754 0 1.377.582 1.42 1.328l.78 13.222a1.4 1.4 0 0 1-1.404 1.475"
				/>
				<path
					fill="#CD0400"
					fillRule="nonzero"
					d="M11.58 1c1.892 0 3.446 1.512 3.5 3.384l.002.102v3.392a.383.383 0 0 1-.764.045l-.003-.045V4.486c0-1.494-1.23-2.72-2.734-2.72a2.737 2.737 0 0 0-2.733 2.627l-.002.093v3.392a.383.383 0 0 1-.764.045l-.003-.045V4.486C8.08 2.567 9.654 1 11.581 1"
				/>
				<g transform="translate(10.837 10.99)">
					<mask id="b" fill="#fff">
						<use xlinkHref="#a" />
					</mask>
					<path
						fill="#CD0400"
						d="M10.255.32c-.324 0-.482-.063-.65-.13A1.8 1.8 0 0 0 8.839.04c-.385 0-.589.08-.769.151a1.5 1.5 0 0 1-.648.13c-.323 0-.482-.063-.65-.13A1.8 1.8 0 0 0 6.005.04c-.385 0-.589.08-.768.151a1.5 1.5 0 0 1-.65.13c-.323 0-.48-.063-.648-.13A1.8 1.8 0 0 0 3.17.04c-.386 0-.588.08-.768.151a1.5 1.5 0 0 1-.65.13c-.323 0-.48-.063-.649-.13A1.8 1.8 0 0 0 .336.04v.316c.323 0 .482.063.649.13.18.07.383.151.767.151.386 0 .589-.08.768-.152.168-.066.326-.129.65-.129.323 0 .481.063.649.13.179.07.383.151.768.151s.588-.08.768-.152c.167-.066.325-.129.65-.129.322 0 .48.063.647.13.18.07.384.151.768.151.386 0 .589-.08.769-.152.167-.066.325-.129.649-.129.323 0 .481.063.649.13.18.07.383.151.768.151.384 0 .588-.08.768-.152.167-.066.325-.129.649-.129V.04c-.385 0-.589.08-.768.151a1.5 1.5 0 0 1-.65.13"
						mask="url(#b)"
					/>
				</g>
				<g transform="translate(10.837 10.99)">
					<mask id="d" fill="#fff">
						<use xlinkHref="#c" />
					</mask>
					<path
						fill="#CD0400"
						d="M10.255 1.442c-.324 0-.482-.062-.65-.129a1.8 1.8 0 0 0-.767-.151c-.385 0-.589.08-.769.151a1.5 1.5 0 0 1-.648.129c-.323 0-.482-.062-.65-.129a1.8 1.8 0 0 0-.767-.151c-.385 0-.589.08-.768.151a1.5 1.5 0 0 1-.65.129c-.323 0-.48-.062-.648-.129a1.8 1.8 0 0 0-.768-.151c-.386 0-.588.08-.768.151a1.5 1.5 0 0 1-.65.129c-.323 0-.48-.062-.649-.129a1.8 1.8 0 0 0-.767-.151v.316c.323 0 .482.063.649.129.18.071.383.152.767.152.386 0 .589-.08.768-.152.168-.066.326-.129.65-.129.323 0 .481.063.649.129.179.071.383.152.768.152s.588-.08.768-.152c.167-.066.325-.129.65-.129.322 0 .48.063.647.129.18.071.384.152.768.152.386 0 .589-.08.769-.152.167-.066.325-.129.649-.129.323 0 .481.063.649.129.18.071.383.152.768.152.384 0 .588-.08.768-.152.167-.066.325-.129.649-.129v-.316c-.385 0-.589.08-.768.151a1.5 1.5 0 0 1-.65.129"
						mask="url(#d)"
					/>
				</g>
				<g transform="translate(10.837 10.99)">
					<mask id="f" fill="#fff">
						<use xlinkHref="#e" />
					</mask>
					<path
						fill="#CD0400"
						d="M10.886 2.442c-.161.064-.319.123-.63.123-.314 0-.472-.059-.633-.123l-.018-.007c-.18-.07-.382-.151-.767-.151s-.589.08-.768.151l-.017.007c-.162.064-.32.123-.632.123-.313 0-.471-.059-.632-.123l-.018-.007c-.179-.07-.382-.151-.767-.151s-.589.08-.768.151l-.018.007a1.5 1.5 0 0 1-.631.123 1.5 1.5 0 0 1-.633-.123l-.016-.007c-.18-.07-.383-.151-.768-.151s-.589.08-.768.151l-.017.007c-.161.064-.32.123-.632.123-.313 0-.47-.059-.632-.123l-.017-.007c-.18-.07-.383-.151-.768-.151V2.6c.323 0 .481.062.649.129.18.071.383.151.768.151s.588-.08.768-.151a1.5 1.5 0 0 1 .649-.13c.323 0 .481.063.649.13.18.071.383.151.768.151s.588-.08.768-.151c.167-.067.325-.13.649-.13.323 0 .481.063.649.13.18.071.383.151.768.151s.588-.08.768-.151a1.5 1.5 0 0 1 .649-.13c.323 0 .481.063.649.13.18.071.382.151.768.151.384 0 .588-.08.768-.151.167-.067.325-.13.648-.13v-.316c-.384 0-.588.08-.768.151z"
						mask="url(#f)"
					/>
				</g>
				<g transform="translate(10.837 10.99)">
					<mask id="h" fill="#fff">
						<use xlinkHref="#g" />
					</mask>
					<path
						fill="#CD0400"
						d="M10.255 3.687c-.324 0-.482-.062-.65-.129a1.8 1.8 0 0 0-.767-.151c-.385 0-.589.08-.769.151a1.5 1.5 0 0 1-.648.13c-.323 0-.482-.063-.65-.13a1.8 1.8 0 0 0-.767-.151c-.385 0-.589.08-.768.151a1.5 1.5 0 0 1-.65.13c-.323 0-.48-.063-.648-.13a1.8 1.8 0 0 0-.768-.151c-.386 0-.588.08-.768.151a1.5 1.5 0 0 1-.65.13c-.323 0-.48-.063-.649-.13a1.8 1.8 0 0 0-.767-.151v.316c.323 0 .482.063.649.13.18.07.383.151.767.151.386 0 .589-.08.768-.152.168-.066.326-.129.65-.129.323 0 .481.063.649.13.179.07.383.151.768.151s.588-.08.768-.152c.167-.066.325-.129.65-.129.322 0 .48.063.647.13.18.07.384.151.768.151.386 0 .589-.08.769-.152.167-.066.325-.129.649-.129.323 0 .481.063.649.13.18.07.383.151.768.151.384 0 .588-.08.768-.152.167-.066.325-.129.649-.129v-.316c-.385 0-.589.08-.768.151a1.5 1.5 0 0 1-.65.13"
						mask="url(#h)"
					/>
				</g>
				<g transform="translate(10.837 10.99)">
					<mask id="j" fill="#fff">
						<use xlinkHref="#i" />
					</mask>
					<path
						fill="#CD0400"
						d="M10.255 4.81c-.324 0-.482-.063-.65-.129a1.8 1.8 0 0 0-.767-.152c-.385 0-.589.08-.769.152a1.5 1.5 0 0 1-.648.129c-.323 0-.482-.063-.65-.129a1.8 1.8 0 0 0-.767-.152c-.385 0-.589.08-.768.152a1.5 1.5 0 0 1-.65.129c-.323 0-.48-.063-.648-.129a1.8 1.8 0 0 0-.768-.152c-.386 0-.588.08-.768.152a1.5 1.5 0 0 1-.65.129c-.323 0-.48-.063-.649-.129a1.8 1.8 0 0 0-.767-.152v.317c.323 0 .482.062.649.129.18.071.383.152.767.152.386 0 .589-.08.768-.152.168-.067.326-.129.65-.129.323 0 .481.062.649.129.179.071.383.152.768.152s.588-.08.768-.152c.167-.067.325-.129.65-.129.322 0 .48.062.647.129.18.071.384.152.768.152.386 0 .589-.08.769-.152.167-.067.325-.129.649-.129.323 0 .481.062.649.129.18.071.383.152.768.152.384 0 .588-.08.768-.152.167-.067.325-.129.649-.129v-.317c-.385 0-.589.08-.768.152a1.5 1.5 0 0 1-.65.129"
						mask="url(#j)"
					/>
				</g>
				<g transform="translate(10.837 10.99)">
					<mask id="l" fill="#fff">
						<use xlinkHref="#k" />
					</mask>
					<path
						fill="#CD0400"
						d="M10.255 5.933c-.324 0-.482-.063-.65-.13a1.8 1.8 0 0 0-.767-.15c-.385 0-.589.08-.769.15a1.5 1.5 0 0 1-.648.13c-.323 0-.482-.063-.65-.13a1.8 1.8 0 0 0-.767-.15c-.385 0-.589.08-.768.15a1.5 1.5 0 0 1-.65.13c-.323 0-.48-.063-.648-.13a1.8 1.8 0 0 0-.768-.15c-.386 0-.588.08-.768.15a1.5 1.5 0 0 1-.65.13c-.323 0-.48-.063-.649-.13a1.8 1.8 0 0 0-.767-.15v.316c.323 0 .482.063.649.129.18.07.383.151.767.151.386 0 .589-.08.768-.151.168-.066.326-.13.65-.13.323 0 .481.064.649.13.179.07.383.151.768.151s.588-.08.768-.151c.167-.066.325-.13.65-.13.322 0 .48.064.647.13.18.07.384.151.768.151.386 0 .589-.08.769-.151.167-.066.325-.13.649-.13.323 0 .481.064.649.13.18.07.383.151.768.151.384 0 .588-.08.768-.151.167-.066.325-.13.649-.13v-.316c-.385 0-.589.08-.768.152a1.5 1.5 0 0 1-.65.129"
						mask="url(#l)"
					/>
				</g>
				<g transform="translate(10.837 10.99)">
					<mask id="n" fill="#fff">
						<use xlinkHref="#m" />
					</mask>
					<path
						fill="#CD0400"
						d="M10.255 7.055c-.324 0-.482-.062-.65-.129a1.8 1.8 0 0 0-.767-.151c-.385 0-.589.08-.769.151a1.5 1.5 0 0 1-.648.13c-.323 0-.482-.063-.65-.13a1.8 1.8 0 0 0-.767-.151c-.385 0-.589.08-.768.151a1.5 1.5 0 0 1-.65.13c-.323 0-.48-.063-.648-.13a1.8 1.8 0 0 0-.768-.151c-.386 0-.588.08-.768.151a1.5 1.5 0 0 1-.65.13c-.323 0-.48-.063-.649-.13a1.8 1.8 0 0 0-.767-.151v.316c.323 0 .482.063.649.13.18.07.383.151.767.151.386 0 .589-.08.768-.152.168-.066.326-.129.65-.129.323 0 .481.063.649.13.179.07.383.151.768.151s.588-.08.768-.152c.167-.066.325-.129.65-.129.322 0 .48.063.647.13.18.07.384.151.768.151.386 0 .589-.08.769-.152.167-.066.325-.129.649-.129.323 0 .481.063.649.13.18.07.383.151.768.151.384 0 .588-.08.768-.152.167-.066.325-.129.649-.129v-.316c-.385 0-.589.08-.768.151a1.5 1.5 0 0 1-.65.13"
						mask="url(#n)"
					/>
				</g>
				<g transform="translate(10.837 10.99)">
					<mask id="p" fill="#fff">
						<use xlinkHref="#o" />
					</mask>
					<path
						fill="#CD0400"
						d="M10.886 8.056c-.161.063-.319.122-.63.122-.314 0-.472-.059-.633-.122l-.018-.008c-.18-.07-.382-.151-.767-.151s-.589.08-.768.151l-.017.008c-.162.063-.32.122-.632.122-.313 0-.471-.059-.632-.122l-.018-.008c-.179-.07-.382-.151-.767-.151s-.589.08-.768.151l-.018.008a1.5 1.5 0 0 1-.631.122c-.312 0-.47-.059-.633-.122l-.016-.008c-.18-.07-.383-.151-.768-.151s-.589.08-.768.151l-.017.008c-.161.063-.32.122-.632.122-.313 0-.47-.059-.632-.122l-.017-.008c-.18-.07-.383-.151-.768-.151v.317c.323 0 .481.063.649.13.18.07.383.15.768.15s.588-.08.768-.15a1.5 1.5 0 0 1 .649-.13c.323 0 .481.063.649.13.18.07.383.15.768.15s.588-.08.768-.15c.167-.067.325-.13.649-.13.323 0 .481.063.649.13.18.07.383.15.768.15s.588-.08.768-.15a1.5 1.5 0 0 1 .649-.13c.323 0 .481.063.649.13.18.07.382.15.768.15.384 0 .588-.08.768-.15.167-.067.325-.13.648-.13v-.318c-.384 0-.588.082-.768.152z"
						mask="url(#p)"
					/>
				</g>
				<g transform="translate(10.837 10.99)">
					<mask id="r" fill="#fff">
						<use xlinkHref="#q" />
					</mask>
					<path
						fill="#CD0400"
						d="M10.255 9.3c-.324 0-.482-.062-.65-.128a1.8 1.8 0 0 0-.767-.152c-.385 0-.589.08-.769.152a1.5 1.5 0 0 1-.648.128c-.323 0-.482-.062-.65-.128a1.8 1.8 0 0 0-.767-.152c-.385 0-.589.08-.768.152a1.5 1.5 0 0 1-.65.128c-.323 0-.48-.062-.648-.128a1.8 1.8 0 0 0-.768-.152c-.386 0-.588.08-.768.152a1.5 1.5 0 0 1-.65.128c-.323 0-.48-.062-.649-.128a1.8 1.8 0 0 0-.767-.152v.317c.323 0 .482.063.649.129.18.071.383.152.767.152.386 0 .589-.081.768-.152.168-.066.326-.13.65-.13.323 0 .481.063.649.13.179.071.383.152.768.152s.588-.081.768-.152c.167-.066.325-.13.65-.13.322 0 .48.063.647.13.18.071.384.152.768.152.386 0 .589-.081.769-.152.167-.066.325-.13.649-.13.323 0 .481.063.649.13.18.071.383.152.768.152.384 0 .588-.081.768-.152.167-.066.325-.13.649-.13V9.02c-.385 0-.589.08-.768.152a1.5 1.5 0 0 1-.65.128"
						mask="url(#r)"
					/>
				</g>
				<g transform="translate(10.837 10.99)">
					<mask id="t" fill="#fff">
						<use xlinkHref="#s" />
					</mask>
					<path
						fill="#CD0400"
						d="M10.255 10.423c-.324 0-.482-.062-.65-.129a1.8 1.8 0 0 0-.767-.151c-.385 0-.589.08-.769.151a1.5 1.5 0 0 1-.648.13c-.323 0-.482-.063-.65-.13a1.8 1.8 0 0 0-.767-.151c-.385 0-.589.08-.768.151a1.5 1.5 0 0 1-.65.13c-.323 0-.48-.063-.648-.13a1.8 1.8 0 0 0-.768-.151c-.386 0-.588.08-.768.151a1.5 1.5 0 0 1-.65.13c-.323 0-.48-.063-.649-.13a1.8 1.8 0 0 0-.767-.151v.316c.323 0 .482.063.649.13.18.07.383.15.767.15.386 0 .589-.08.768-.15.168-.067.326-.13.65-.13.323 0 .481.063.649.13.179.07.383.15.768.15s.588-.08.768-.15c.167-.067.325-.13.65-.13.322 0 .48.063.647.13.18.07.384.15.768.15.386 0 .589-.08.769-.15.167-.067.325-.13.649-.13.323 0 .481.063.649.13.18.07.383.15.768.15.384 0 .588-.08.768-.15.167-.067.325-.13.649-.13v-.316c-.385 0-.589.08-.768.151a1.5 1.5 0 0 1-.65.13"
						mask="url(#t)"
					/>
				</g>
				<g transform="translate(2.98 10.99)">
					<mask id="v" fill="#fff">
						<use xlinkHref="#u" />
					</mask>
					<path
						fill="#CD0400"
						d="M6.776.32c-.323 0-.482-.063-.649-.13A1.8 1.8 0 0 0 5.359.04c-.385 0-.588.08-.768.151a1.5 1.5 0 0 1-.649.13c-.323 0-.481-.063-.649-.13A1.8 1.8 0 0 0 2.526.04c-.386 0-.59.08-.768.151a1.5 1.5 0 0 1-.65.13C.785.32.627.256.46.19A1.8 1.8 0 0 0-.309.04c-.385 0-.588.08-.767.151a1.5 1.5 0 0 1-.65.13c-.323 0-.481-.063-.65-.13A1.8 1.8 0 0 0-3.142.04v.316c.324 0 .482.063.65.13.179.07.382.151.767.151.386 0 .588-.08.768-.152.168-.066.326-.129.65-.129.323 0 .48.063.648.13.18.07.383.151.768.151s.588-.08.768-.152c.168-.066.326-.129.65-.129.323 0 .48.063.648.13.18.07.383.151.768.151s.588-.08.768-.152a1.5 1.5 0 0 1 .65-.129c.323 0 .48.063.648.13.18.07.383.151.768.151s.588-.08.768-.152c.167-.066.325-.129.649-.129V.04c-.385 0-.588.08-.768.151a1.5 1.5 0 0 1-.649.13"
						mask="url(#v)"
					/>
				</g>
				<g transform="translate(2.98 10.99)">
					<mask id="x" fill="#fff">
						<use xlinkHref="#w" />
					</mask>
					<path
						fill="#CD0400"
						d="M6.776 1.442c-.323 0-.482-.062-.649-.129a1.8 1.8 0 0 0-.768-.151c-.385 0-.588.08-.768.151a1.5 1.5 0 0 1-.649.129c-.323 0-.481-.062-.649-.129a1.8 1.8 0 0 0-.767-.151c-.386 0-.59.08-.768.151a1.5 1.5 0 0 1-.65.129c-.323 0-.481-.062-.649-.129a1.8 1.8 0 0 0-.768-.151c-.385 0-.588.08-.767.151a1.5 1.5 0 0 1-.65.129c-.323 0-.481-.062-.65-.129a1.8 1.8 0 0 0-.767-.151v.316c.324 0 .482.063.65.129.179.071.382.152.767.152.386 0 .588-.08.768-.152.168-.066.326-.129.65-.129.323 0 .48.063.648.129.18.071.383.152.768.152s.588-.08.768-.152c.168-.066.326-.129.65-.129.323 0 .48.063.648.129.18.071.383.152.768.152s.588-.08.768-.152a1.5 1.5 0 0 1 .65-.129c.323 0 .48.063.648.129.18.071.383.152.768.152s.588-.08.768-.152c.167-.066.325-.129.649-.129v-.316c-.385 0-.588.08-.768.151a1.5 1.5 0 0 1-.649.129"
						mask="url(#x)"
					/>
				</g>
				<g transform="translate(2.98 10.99)">
					<mask id="z" fill="#fff">
						<use xlinkHref="#y" />
					</mask>
					<path
						fill="#CD0400"
						d="M7.408 2.442c-.162.064-.32.123-.632.123s-.47-.059-.632-.123l-.017-.007c-.18-.07-.382-.151-.768-.151-.385 0-.588.08-.768.151l-.017.007c-.161.064-.32.123-.632.123s-.47-.059-.632-.123l-.017-.007c-.18-.07-.383-.151-.768-.151s-.588.08-.768.151l-.017.007a1.5 1.5 0 0 1-.632.123c-.312 0-.47-.059-.632-.123l-.017-.007c-.18-.07-.383-.151-.768-.151s-.588.08-.768.151l-.017.007c-.161.064-.32.123-.632.123s-.47-.059-.631-.123l-.018-.007c-.179-.07-.383-.151-.768-.151V2.6c.324 0 .482.062.65.129.179.071.382.151.767.151s.588-.08.768-.151a1.5 1.5 0 0 1 .649-.13c.324 0 .482.063.65.13.179.071.382.151.767.151s.589-.08.768-.151c.167-.067.326-.13.649-.13.324 0 .482.063.65.13.179.071.382.151.767.151s.589-.08.768-.151a1.5 1.5 0 0 1 .65-.13c.322 0 .48.063.648.13.18.071.383.151.768.151s.589-.08.768-.151c.167-.067.326-.13.649-.13v-.316c-.385 0-.589.08-.768.151z"
						mask="url(#z)"
					/>
				</g>
				<g transform="translate(2.98 10.99)">
					<mask id="B" fill="#fff">
						<use xlinkHref="#A" />
					</mask>
					<path
						fill="#CD0400"
						d="M6.776 3.687c-.323 0-.482-.062-.649-.129a1.8 1.8 0 0 0-.768-.151c-.385 0-.588.08-.768.151a1.5 1.5 0 0 1-.649.13c-.323 0-.481-.063-.649-.13a1.8 1.8 0 0 0-.767-.151c-.386 0-.59.08-.768.151a1.5 1.5 0 0 1-.65.13c-.323 0-.481-.063-.649-.13a1.8 1.8 0 0 0-.768-.151c-.385 0-.588.08-.767.151a1.5 1.5 0 0 1-.65.13c-.323 0-.481-.063-.65-.13a1.8 1.8 0 0 0-.767-.151v.316c.324 0 .482.063.65.13.179.07.382.151.767.151.386 0 .588-.08.768-.152.168-.066.326-.129.65-.129.323 0 .48.063.648.13.18.07.383.151.768.151s.588-.08.768-.152c.168-.066.326-.129.65-.129.323 0 .48.063.648.13.18.07.383.151.768.151s.588-.08.768-.152a1.5 1.5 0 0 1 .65-.129c.323 0 .48.063.648.13.18.07.383.151.768.151s.588-.08.768-.152c.167-.066.325-.129.649-.129v-.316c-.385 0-.588.08-.768.151a1.5 1.5 0 0 1-.649.13"
						mask="url(#B)"
					/>
				</g>
				<g transform="translate(2.98 10.99)">
					<mask id="D" fill="#fff">
						<use xlinkHref="#C" />
					</mask>
					<path
						fill="#CD0400"
						d="M6.776 4.81c-.323 0-.482-.063-.649-.129a1.8 1.8 0 0 0-.768-.152c-.385 0-.588.08-.768.152a1.5 1.5 0 0 1-.649.129c-.323 0-.481-.063-.649-.129a1.8 1.8 0 0 0-.767-.152c-.386 0-.59.08-.769.152a1.5 1.5 0 0 1-.649.129c-.323 0-.481-.063-.649-.129a1.8 1.8 0 0 0-.768-.152c-.385 0-.588.08-.767.152a1.5 1.5 0 0 1-.65.129c-.323 0-.481-.063-.65-.129a1.8 1.8 0 0 0-.767-.152v.317c.324 0 .482.062.65.129.179.071.382.152.767.152.386 0 .588-.08.768-.152.168-.067.326-.129.65-.129.323 0 .48.062.648.129.18.071.383.152.768.152s.588-.08.768-.152c.168-.067.326-.129.65-.129.323 0 .48.062.648.129.18.071.383.152.768.152s.588-.08.768-.152a1.5 1.5 0 0 1 .65-.129c.323 0 .48.062.648.129.18.071.383.152.768.152s.588-.08.768-.152c.167-.067.325-.129.649-.129v-.317c-.385 0-.588.08-.768.152a1.5 1.5 0 0 1-.649.129"
						mask="url(#D)"
					/>
				</g>
				<g transform="translate(2.98 10.99)">
					<mask id="F" fill="#fff">
						<use xlinkHref="#E" />
					</mask>
					<path
						fill="#CD0400"
						d="M6.776 5.933c-.323 0-.482-.063-.649-.13a1.8 1.8 0 0 0-.768-.15c-.385 0-.588.08-.768.15a1.5 1.5 0 0 1-.649.13c-.323 0-.481-.063-.649-.13a1.8 1.8 0 0 0-.767-.15c-.386 0-.59.08-.768.15a1.5 1.5 0 0 1-.65.13c-.323 0-.481-.063-.649-.13a1.8 1.8 0 0 0-.768-.15c-.385 0-.588.08-.767.15a1.5 1.5 0 0 1-.65.13c-.323 0-.481-.063-.65-.13a1.8 1.8 0 0 0-.767-.15v.316c.324 0 .482.063.65.129.179.07.382.151.767.151.386 0 .588-.08.768-.151.168-.066.326-.13.65-.13.323 0 .48.064.648.13.18.07.383.151.768.151s.588-.08.768-.151c.168-.066.326-.13.65-.13.323 0 .48.064.648.13.18.07.383.151.768.151s.588-.08.768-.151c.168-.066.326-.13.65-.13.323 0 .48.064.648.13.18.07.383.151.768.151s.588-.08.768-.151c.167-.066.325-.13.649-.13v-.316c-.385 0-.588.08-.768.152a1.5 1.5 0 0 1-.649.129"
						mask="url(#F)"
					/>
				</g>
				<g transform="translate(2.98 10.99)">
					<mask id="H" fill="#fff">
						<use xlinkHref="#G" />
					</mask>
					<path
						fill="#CD0400"
						d="M6.776 7.055c-.323 0-.482-.062-.649-.129a1.8 1.8 0 0 0-.768-.151c-.385 0-.588.08-.768.151a1.5 1.5 0 0 1-.649.13c-.323 0-.481-.063-.649-.13a1.8 1.8 0 0 0-.767-.151c-.386 0-.59.08-.768.151a1.5 1.5 0 0 1-.65.13c-.323 0-.481-.063-.649-.13a1.8 1.8 0 0 0-.768-.151c-.385 0-.588.08-.767.151a1.5 1.5 0 0 1-.65.13c-.323 0-.481-.063-.65-.13a1.8 1.8 0 0 0-.767-.151v.316c.324 0 .482.063.65.13.179.07.382.151.767.151.386 0 .588-.08.768-.152.168-.066.326-.129.65-.129.323 0 .48.063.648.13.18.07.383.151.768.151s.588-.08.768-.152c.168-.066.326-.129.65-.129.323 0 .48.063.648.13.18.07.383.151.768.151s.588-.08.768-.152c.168-.066.326-.129.65-.129.323 0 .48.063.648.13.18.07.383.151.768.151s.588-.08.768-.152c.167-.066.325-.129.649-.129v-.316c-.385 0-.588.08-.768.151a1.5 1.5 0 0 1-.649.13"
						mask="url(#H)"
					/>
				</g>
				<g transform="translate(2.98 10.99)">
					<mask id="J" fill="#fff">
						<use xlinkHref="#I" />
					</mask>
					<path
						fill="#CD0400"
						d="M7.408 8.056c-.162.063-.32.122-.632.122s-.47-.059-.632-.122l-.017-.008c-.18-.07-.382-.151-.768-.151-.385 0-.588.08-.768.151l-.017.008c-.161.063-.32.122-.632.122s-.47-.059-.632-.122l-.017-.008c-.18-.07-.383-.151-.768-.151s-.588.08-.768.151l-.017.008a1.5 1.5 0 0 1-.632.122c-.312 0-.47-.059-.632-.122l-.017-.008c-.18-.07-.383-.151-.768-.151s-.588.08-.768.151l-.017.008c-.161.063-.32.122-.632.122s-.47-.059-.631-.122l-.018-.008c-.179-.07-.383-.151-.768-.151v.317c.324 0 .482.063.65.13.179.07.382.15.767.15s.588-.08.768-.15a1.5 1.5 0 0 1 .649-.13c.324 0 .482.063.65.13.179.07.382.15.767.15s.589-.08.768-.15c.167-.067.326-.13.649-.13.324 0 .482.063.65.13.179.07.382.15.767.15s.589-.08.768-.15a1.5 1.5 0 0 1 .65-.13c.322 0 .48.063.648.13.18.07.383.15.768.15s.589-.08.768-.15c.167-.067.326-.13.649-.13v-.318c-.385 0-.589.082-.768.152z"
						mask="url(#J)"
					/>
				</g>
				<g transform="translate(2.98 10.99)">
					<mask id="L" fill="#fff">
						<use xlinkHref="#K" />
					</mask>
					<path
						fill="#CD0400"
						d="M6.776 9.3c-.323 0-.482-.062-.649-.128a1.8 1.8 0 0 0-.768-.152c-.385 0-.588.08-.768.152a1.5 1.5 0 0 1-.649.128c-.323 0-.481-.062-.649-.128a1.8 1.8 0 0 0-.767-.152c-.386 0-.59.08-.768.152a1.5 1.5 0 0 1-.65.128c-.323 0-.481-.062-.649-.128a1.8 1.8 0 0 0-.768-.152c-.385 0-.588.08-.767.152a1.5 1.5 0 0 1-.65.128c-.323 0-.481-.062-.65-.128a1.8 1.8 0 0 0-.767-.152v.317c.324 0 .482.063.65.129.179.071.382.152.767.152.386 0 .588-.081.768-.152.168-.066.326-.13.65-.13.323 0 .48.063.648.13.18.071.383.152.768.152s.588-.081.768-.152c.168-.066.326-.13.65-.13.323 0 .48.063.648.13.18.071.383.152.768.152s.588-.081.768-.152c.168-.066.326-.13.65-.13.323 0 .48.063.648.13.18.071.383.152.768.152s.588-.081.768-.152c.167-.066.325-.13.649-.13V9.02c-.385 0-.588.08-.768.152a1.5 1.5 0 0 1-.649.128"
						mask="url(#L)"
					/>
				</g>
				<g transform="translate(2.98 10.99)">
					<mask id="N" fill="#fff">
						<use xlinkHref="#M" />
					</mask>
					<path
						fill="#CD0400"
						d="M6.776 10.423c-.323 0-.482-.062-.649-.129a1.8 1.8 0 0 0-.768-.151c-.385 0-.588.08-.768.151a1.5 1.5 0 0 1-.649.13c-.323 0-.481-.063-.649-.13a1.8 1.8 0 0 0-.767-.151c-.386 0-.59.08-.769.151a1.5 1.5 0 0 1-.649.13c-.323 0-.481-.063-.649-.13a1.8 1.8 0 0 0-.768-.151c-.385 0-.588.08-.767.151a1.5 1.5 0 0 1-.65.13c-.323 0-.481-.063-.65-.13a1.8 1.8 0 0 0-.767-.151v.316c.324 0 .482.063.65.13.179.07.382.15.767.15.386 0 .588-.08.768-.15.168-.067.326-.13.65-.13.323 0 .48.063.648.13.18.07.383.15.768.15s.588-.08.768-.15c.168-.067.326-.13.65-.13.323 0 .48.063.648.13.18.07.383.15.768.15s.588-.08.768-.15c.168-.067.326-.13.65-.13.323 0 .48.063.648.13.18.07.383.15.768.15s.588-.08.768-.15c.167-.067.325-.13.649-.13v-.316c-.385 0-.588.08-.768.151a1.5 1.5 0 0 1-.649.13"
						mask="url(#N)"
					/>
				</g>
			</g>
		</svg>
	);
}
